export default {
  parentTabId: {
    type: 'string',
    default: '',
  },
  havePlans: {
    type: 'boolean',
    default: false,
  },
  plansId: {
    type: 'string',
    default: '',
  },
};
